import b from 'b_';
import cx from 'classnames';
import { ChevroneKit as Chevrone } from 'education-icons';
import { Link } from 'platform-components';
import { Button, SimpleCallback } from 'platform-components/common';
import React from 'react';
import { useMedia } from 'react-use';

import { COURSE_CONTAINER_MOBILE_QUERY } from '../constants';

import './course-container__arrow-button.scss';

export enum ArrowButtonDirection {
    RIGHT = 'right',
    LEFT = 'left',
}

interface Props {
    className?: string;
    onClick?: SimpleCallback;
    link?: React.ComponentProps<typeof Link>['to'];
    direction: ArrowButtonDirection;
}

export const CourseContainerArrowButton = ({ className, direction, link, onClick }: Props) => {
    const isMobile = useMedia(COURSE_CONTAINER_MOBILE_QUERY);
    const size = isMobile ? Button.SIZE.S : Button.SIZE.L;

    if (!link) {
        return (
            <Button
                className={cx(b('course-container', 'arrow-button', { direction }), className)}
                icon={<Chevrone />}
                onClick={onClick}
                rounded
                size={size}
                view={Button.VIEW.RAISED}
            />
        );
    }

    return (
        <Link className={className} isRouter to={link}>
            <Button
                className={cx(b('course-container', 'arrow-button', { direction }))}
                icon={<Chevrone />}
                onClick={onClick}
                rounded
                size={size}
                view={Button.VIEW.RAISED}
            />
        </Link>
    );
};

CourseContainerArrowButton.DIRECTION = ArrowButtonDirection;
